const accordions = document.querySelectorAll(".accordion");

accordions.forEach((accordion) => {
  accordion.addEventListener("click", function () {
    const panel = this.nextElementSibling;
    const isActive = this.classList.contains("active");

    // Handle optional scroll logic (unchanged)
    const product_information = this.classList.contains("product_info");
    if (product_information) {
      const prevSibling = this.parentElement.previousElementSibling;
      const scrollToTop = (height) => {
        const scrollToY = this.parentElement.offsetTop - height;
        window.scrollTo({
          top: scrollToY + (window.innerWidth < 768 ? 100 : 40),
          left: 0,
          behavior: "smooth",
        });
      };

      if (prevSibling) {
        if (prevSibling.children[0].classList.contains("active")) {
          scrollToTop(prevSibling.parentElement.offsetHeight);
        } else {
          const nextElementSibling = prevSibling.previousElementSibling;
          if (
            nextElementSibling &&
            nextElementSibling.children[0].classList.contains("active")
          ) {
            scrollToTop(nextElementSibling.parentElement.offsetHeight);
          }
        }
      } else {
        scrollToTop(200);
      }
    }

    // Only close sibling accordions at the same level
    const thisAccordionSingle = this.closest(".accordion-single");
    const siblingAccordions = thisAccordionSingle?.parentElement?.querySelectorAll(
      ":scope > .accordion-single > .accordion"
    );

    siblingAccordions?.forEach((acc) => {
      if (acc !== this) {
        acc.classList.remove("active");
        if (acc.nextElementSibling?.style) {
          acc.nextElementSibling.style.maxHeight = null;
        }
      }
    });

    // Toggle current accordion
    if (!isActive) {
      this.classList.add("active");

      if (panel?.style) {
        panel.style.maxHeight = panel.scrollHeight + "px";

        // Expand all parent panels upward
        let parent = panel.parentElement;
        while (parent) {
          const parentPanel = parent.closest(".panel");
          if (parentPanel) {
            parentPanel.style.maxHeight = "100vh";
          }
          parent = parentPanel?.parentElement;
        }
      }
    } else {
      // Collapsing this accordion
      this.classList.remove("active");
      if (panel?.style) {
        panel.style.maxHeight = null;
      }

      // Auto-collapse all child accordions inside this panel when a parent is collapsed
      if (panel) {
        const childAccordions = panel.querySelectorAll(".accordion.active");
        childAccordions.forEach((childAccordion) => {
          childAccordion.classList.remove("active");
          const childPanel = childAccordion.nextElementSibling;
          if (childPanel?.style) {
            childPanel.style.maxHeight = null;
          }
        });
      }
    }
  });
});
